"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("Paging");

var PartialResponseHelper = require("../shared/PartialResponseHelper");

class Paging extends React.Component {
	constructor(props) {
		super(props);

		var currentPageNumber = props.currentPageNumber;
		var pageSize = props.pageSize || 10;
		var totalCount = props.totalCount;

		if (props.isDesignMode) {
			currentPageNumber = 10;
			totalCount = 20 * pageSize;
		}

		this.state = {
			currentPageNumber,
			pageSize,
			totalCount
		};
	}

	getLastPageNumber() {
		return Math.ceil(this.state.totalCount / this.state.pageSize);
	}

	setupRelatedComponents() {
		var currentPage = this.state.currentPageNumber;
		var lastPage = this.getLastPageNumber();

		var $paging = $(ReactDOM.findDOMNode(this)).parent(); // The parent is the mount point
		var $previousButton = $paging.siblings(`[data-component="pagingControls.previousPage"]`);
		var $nextButton = $paging.siblings(`[data-component="pagingControls.nextPage"]`);

		$previousButton.prop("onclick", null).off("click");
		if (currentPage > 1) {
			$previousButton.removeClass("disabled");
			$previousButton.click(this.handlePageChange.bind(this, currentPage - 1));
		} else {
			$previousButton.addClass("disabled");
		}

		$nextButton.prop("onclick", null).off("click");
		if (currentPage < lastPage) {
			$nextButton.removeClass("disabled");
			$nextButton.click(this.handlePageChange.bind(this, currentPage + 1));
		} else {
			$nextButton.addClass("disabled");
		}
	}

	handlePageChange(pageNumber, event) {
		var currentPage = this.state.currentPageNumber;
		if (currentPage === pageNumber) {
			return;
		}
		if (this.props.isDesignMode) {
			if (event && !event.ctrlKey && !event.metaKey) {
				return;
			}
			this.setState({ currentPageNumber: pageNumber }, this.setupRelatedComponents);
			return;
		}
		// The parent is the mount point
		var $mountPoint = $(ReactDOM.findDOMNode(this)).parent();
		var $parentComponent = $mountPoint.closest("[data-component='pagingControls']").parents("[data-component]:not([data-component*='.'])").first();

		var layoutId = this.props.layoutId;
		var url = this.props.url + "?";
		var id = $parentComponent.attr("id");
		var limit = this.props.pageSize;

		var params = [];
		if (layoutId) {
			params.push(`layoutId=${layoutId}`);
		}
		params.push(`id=${id}`);
		params.push(`offset=${limit * (pageNumber - 1)}`);
		if (params.length > 0) {
			url += params.join("&");
		}

		$parentComponent.load(url, (response, status) => {
			if (status !== "error" || !PartialResponseHelper.handleErrorResponse(response)) {
				ReactDOM.unmountComponentAtNode($mountPoint[0]);
			}
		});
	}

	componentDidMount() {
		this.setupRelatedComponents();

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
		}
	}

	render() {
		var currentPage = this.state.currentPageNumber;
		var numberPagesToShow = this.props.numberPagesToShow;
		var lastPage = this.getLastPageNumber();

		if (this.props.isDesignMode) {
			numberPagesToShow = numberPagesToShow || 3;
		}

		var pagesToShow = [];
		if (lastPage < numberPagesToShow) {
			pagesToShow = new Array(lastPage).fill().map((e, i) => i + 1);
		} else if (currentPage < numberPagesToShow) {
			pagesToShow = new Array(numberPagesToShow).fill().map((e, i) => i + 1);
		} else {
			var start = currentPage - Math.floor((numberPagesToShow - 1) / 2);
			if (start + numberPagesToShow > lastPage) {
				start = lastPage - numberPagesToShow + 1;
			}
			pagesToShow = new Array(numberPagesToShow).fill().map((e, i) => i + start);
		}

		var includeFirstPageNumber = this.props.includeFirstPageNumber && pagesToShow.indexOf(1) === -1;
		var showStartEllipses = includeFirstPageNumber && pagesToShow.indexOf(2) === -1;
		var includeLastPageNumber = this.props.includeLastPageNumber && pagesToShow.indexOf(lastPage) === -1;
		var showEndEllipses = includeLastPageNumber && pagesToShow.indexOf(lastPage - 1) === -1;

		return (
			<div
				className="paging"
				data-react-component-name="Paging"
				data-react-component-category="PagingComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				{includeFirstPageNumber &&
					<span className={classNames("paging-item page-number", { "current-page": currentPage === 1 })} data-component="Paging.page" onClick={this.handlePageChange.bind(this, 1)}>
						{1}
					</span>
				}
				{showStartEllipses &&
					<span className="paging-item ellipses" data-component="Paging.pageEllipses">
						...
					</span>
				}
				{pagesToShow.map((pageNumber) =>
					<span key={pageNumber} className={classNames("paging-item page-number", { "current-page": currentPage === pageNumber })} data-component="Paging.page" onClick={this.handlePageChange.bind(this, pageNumber)}>
						{pageNumber}
					</span>
				)}
				{showEndEllipses &&
					<span className="paging-item ellipses" data-component="Paging.pageEllipses">
						...
					</span>
				}
				{includeLastPageNumber &&
					<span className={classNames("paging-item page-number", { "current-page": currentPage === lastPage })} data-component="Paging.page" onClick={this.handlePageChange.bind(this, lastPage)}>
						{lastPage}
					</span>
				}
			</div>
		);
	}
}

Paging.propTypes = {
	currentPageNumber: PropTypes.number,
	dataChildOf: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	includeFirstPageNumber: PropTypes.bool,
	includeLastPageNumber: PropTypes.bool,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	layoutId: PropTypes.number,
	numberPagesToShow: PropTypes.number,
	pageSize: PropTypes.number,
	theme: PropTypes.string,
	totalCount: PropTypes.number,
	url: PropTypes.string
};

module.exports = Paging;
